/* To be re-enabled for global/chat panel */
export const RightAdsPanel = (): JSX.Element | null => {
	return null;
};
